<template>
  <div>
    <el-checkbox
      v-model="infoLocal.enable_competencies"
      size="mini"
      border
    >
      Блок "Компетенции"
    </el-checkbox>

    <el-form-item label="Формат">
      <el-select
        v-model="infoLocal.format"
        size="mini"
        @change="valueChanged"
      >
        <el-option label="Для Сотрудников" :value="1"></el-option>
        <el-option label="Для Директоров" :value="2"></el-option>
      </el-select>
    </el-form-item>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "cards-create-info",
  components: {},

  props: {
    info: {type: Object, required:true},
    card: {type: Object},
  },

  computed: {},
  watch: {
    'info': function(newVal){
      this.infoLocal = newVal;
    },
  },
  mounted() {
    this.valueChanged();
  },
  data() {
    return {
      infoLocal: {
        format: 1,
        enable_competencies: false,
      },
    }
  },
  methods: {
    valueChanged(){
      this.$emit('update:info', this.infoLocal);
    }
  }
}
</script>


<style lang="scss">

</style>